import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import {recipientStatFromAPI} from './reducer';

export const fetchRecipients = originatorId =>
    RESTClient.getAuthenticatedObservable(`v2/feed/${originatorId}/recipients`).map(response => ({
        recipients: List(response.logins).map(recipientStatFromAPI),
    }));
